





















import Vue from 'vue';
import { mapGetters } from 'vuex';
import { mapKeys, upperFirst } from 'lodash';

import ObjectMapper from '@/components/object_mapper/ObjectMapper.vue';

import { Audit } from '../types';

export default Vue.extend({
  name: 'ASWStep2',
  components: {
    ObjectMapper,
  },
  props: {
    audit: {
      type: Object as () => Audit,
      required: true,
    },
  },
  data() {
    const startingFilters = <any>{
      object: null,
      type: null,
    };
    const controlType = {
      model: 'Control',
      plural: 'Controls',
      singular: 'Control',
    };
    if (this.audit.relatedProgram.id) {
      startingFilters.object = {
        id: this.audit.relatedProgram.id,
        identifier: this.audit.relatedProgram.value,
        title: this.audit.relatedProgram.label,
      };
      startingFilters.type = {
        model: 'Program',
        plural: 'Programs',
        singular: 'Program',
      };
    }
    return {
      // This will always be hardcoded to Control at this point, but perhaps
      // We can build it using store.modelMeta just in case control gets
      // renamed in the future.
      controlType,
      startingFilters: [startingFilters],
      leftColumnType: {
        model: 'Audit',
        singular: 'Audit',
        plural: 'Audits',
      },
    };
  },
  computed: {
    ...mapGetters({
      csrfToken: 'csrfToken',
      apiEndpoints: 'objectMapperApiEndpoints',
      rawAvailableMapTypes: 'availableMapTypes',
    }),
    availableMapTypes(): any {
      const types = mapKeys(this.rawAvailableMapTypes, (_, key) => upperFirst(key));
      // Allow just Controls to be mapped
      types['Audit'] = [
        {
          model: 'Control',
          plural: 'Controls',
          singular: 'Control',
        },
      ];
      return types;
    },
  },
});
